import { render, staticRenderFns } from "./btnAccess.vue?vue&type=template&id=76a86d6a&scoped=true"
import script from "./btnAccess.vue?vue&type=script&lang=js"
export * from "./btnAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a86d6a",
  null
  
)

export default component.exports